import { Button, CircularProgress, styled } from "@mui/material";

const StyledButton = styled(Button)(() => ({
  background: "#4D6BF6",
  color: "#ffffff",
  boxShadow: "none",
  border: "1px solid #4D6BF6",
  whiteSpace: "nowrap",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "10px",
  padding: ".5vh 1vw",
  letterSpacing: "0",
}));

const GreyStyledButton = styled(Button)(() => ({
  background: "#fff",
  color: "#0D0D0E",
  boxShadow: "none",
  border: "1px solid #D7D8D9",
  whiteSpace: "nowrap",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "10px",
  padding: ".5vh 1vw",
  letterSpacing: "0",
}));

const ActionBar = ({ onCancel, onSubmit, buttonLoader, submitLabel = "Submit" }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexDirection: "row",
        gap: "10px",
        padding: "10px",
        width: "100%",
      }}
    >
      <GreyStyledButton onClick={onCancel}>Cancel</GreyStyledButton>
      <StyledButton variant="contained" onClick={onSubmit}>
        {buttonLoader ? (
          <CircularProgress size={26} style={{ color: "#fff" }} />
        ) : (
          submitLabel
        )}
      </StyledButton>
    </div>
  );
};

export default ActionBar;
